import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledHeader, StyledLogoIcon, StyledLogo, StyledText } from './styled';

export interface IHeaderProps extends IBasicStyledProps {
  linkUrlAddress?: string;
  callCenterText?: string | JSX.Element | null;
  callCenterOpeningHours?: string | JSX.Element | null;
}

export const Header: ReactFCV<IHeaderProps> = ({ linkUrlAddress, callCenterText, callCenterOpeningHours }) => (
  <StyledHeader data-testid="header-component">
    <StyledLogo data-testid="logo" href={linkUrlAddress}>
      <StyledLogoIcon color={'icon.inverse'} width="144px" />
    </StyledLogo>
    <div>
      {Boolean(callCenterText) && <StyledText data-testid="call-center-text">{callCenterText}</StyledText>}
      {Boolean(callCenterOpeningHours) && (
        <StyledText data-testid="call-center-opening-hours">{callCenterOpeningHours}</StyledText>
      )}
    </div>
  </StyledHeader>
);
